/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Autoflower_SeedsInputs */

const en_autoflower_seeds = /** @type {(inputs: Autoflower_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autoflower Seeds`)
};

const th_autoflower_seeds = /** @type {(inputs: Autoflower_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมล็ดพันธุ์ออโต้ฟลาวเวอร์`)
};

const ja_autoflower_seeds = /** @type {(inputs: Autoflower_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オートフラワーシード`)
};

const fr_autoflower_seeds = /** @type {(inputs: Autoflower_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graines à autofloraison`)
};

const es_autoflower_seeds = /** @type {(inputs: Autoflower_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semillas autoflorecientes`)
};

const ru_autoflower_seeds = /** @type {(inputs: Autoflower_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоцветущие семена`)
};

const zh_autoflower_seeds = /** @type {(inputs: Autoflower_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动开花种子`)
};

const vi_autoflower_seeds = /** @type {(inputs: Autoflower_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạt giống tự ra hoa`)
};

/**
* | output |
* | --- |
* | "Autoflower Seeds" |
*
* @param {Autoflower_SeedsInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const autoflower_seeds = /** @type {((inputs?: Autoflower_SeedsInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Autoflower_SeedsInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_autoflower_seeds(inputs)
	if (locale === "ja") return ja_autoflower_seeds(inputs)
	if (locale === "fr") return fr_autoflower_seeds(inputs)
	if (locale === "es") return es_autoflower_seeds(inputs)
	if (locale === "ru") return ru_autoflower_seeds(inputs)
	if (locale === "zh") return zh_autoflower_seeds(inputs)
	if (locale === "vi") return vi_autoflower_seeds(inputs)
	return en_autoflower_seeds(inputs)
});